import { render, staticRenderFns } from "./DeleteBlock.vue?vue&type=template&id=37ca197a&"
import script from "./DeleteBlock.vue?vue&type=script&lang=js&"
export * from "./DeleteBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports